import React from "react";
import FormattedMessage from "components/FormattedMessage/index";
import { CheckCircle } from "components/Icons";
import { AlertCircle } from "components/Icons/index";
import PropTypes from "prop-types";
import { Flex, Text } from "ui-components";

const CompatibleMessage = props => {
  const { iconCondition, messageCondition, errorColor, successColor } = props;
  return (
    <Flex alignItems="center" mb={4}>
      {iconCondition ? (
        <CheckCircle size="20px" color={successColor} />
      ) : (
        <AlertCircle size="20px" color={errorColor} />
      )}
      <Text
        ml={2}
        size="md"
        lineHeight="1.2"
        style={{ whiteSpace: "pre-line" }}
      >
        <FormattedMessage html id={messageCondition}>
          {msg => (
            <span
              style={{
                color: iconCondition ? successColor : errorColor
              }}
            >
              {msg}
            </span>
          )}
        </FormattedMessage>
      </Text>
    </Flex>
  );
};

CompatibleMessage.defaultProps = {
  iconCondition: "",
  messageCondition: ""
};

CompatibleMessage.propTypes = {
  iconCondition: PropTypes.string,
  messageCondition: PropTypes.string
};

export default CompatibleMessage;
